import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../Pages/Home";
import ProjectDetail from "../Pages/ProjectDetail";
import NotFound from "../Pages/NotFound";
import { AnimatePresence } from "framer-motion";
import AboutMe from "../Pages/AboutMe";
import Contact from "../Pages/Contact";
import Work from "../Pages/Work";

function Router() {
  const location = useLocation();
  return (
    <AnimatePresence initial={true} mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/project/:id" element={<ProjectDetail />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/work" element={<Work />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}

export default Router;
